import { render, staticRenderFns } from "./shelfSettingDialog.vue?vue&type=template&id=87fd434c&scoped=true&"
import script from "./shelfSettingDialog.vue?vue&type=script&lang=js&"
export * from "./shelfSettingDialog.vue?vue&type=script&lang=js&"
import style0 from "./shelfSettingDialog.vue?vue&type=style&index=0&id=87fd434c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fd434c",
  null
  
)

export default component.exports